/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'i18n!./DashboardTemplateResources',
	'polyglot'
], function (dashboardTemplateResources, Polyglot) {

	var poly = new Polyglot({
		phrases: dashboardTemplateResources,
		allowMissing: true
	});
	var StringResources = function () { };

	/**
	* Get the string resource for the given key and interpolation options. Checks the DashboardTemplate resources first and if
	* not found it checks the Dashboard resources.
	*
	* @param key						The  key of the string to return
	* @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
	* @returns							The string to display
	*/
	StringResources.prototype.get = function (key, interpolationOptions) {
		return poly.t(key, interpolationOptions);
	};

	return new StringResources();
});